import { useShallow } from 'zustand/react/shallow';

import { useAppStore } from '@/data-store/appStoreProvider';
import { ShopifyState } from '@/data-store/slices/shopifySlice';

// https://stackoverflow.com/questions/68609189/fetching-multiple-states-with-zustand-react-shorthand-syntax
const useShopifyStore = <T extends ShopifyState, K extends keyof ShopifyState>(
  ...items: K[]
): Pick<T, K> => {
  const selectedItems = useAppStore(
    useShallow((state) =>
      items.reduce((acc, item) => ({ ...acc, [item]: state.shopify[item] }), {})
    )
  );
  return selectedItems as Pick<T, K>;
};

export const useShopifyActions = () =>
  useAppStore((state) => state.shopify.actions);

export default useShopifyStore;
